import React from "react";
import styled from "styled-components";
import { useSelector } from "react-redux";
import { selectMode } from "../../app/appSlice";
import { Link } from "react-router-dom";
import { Container, Row, Col, Button } from "react-bootstrap";
import Title from "../Title";
import { Element } from "react-scroll";

// Import preview images
import bridgeImg from "../../images/gallery-bridge.jpeg";
import citiesAfarImg from "../../images/gallery-cities-afar.jpeg";
import mountRainierImg from "../../images/gallery-mount-rainier-together.jpeg";

const StyledSection = styled.section`
  padding: 4rem 0;
  
  .gallery-container {
    max-width: 1200px;
    margin: 0 auto;
  }
  
  .gallery-item {
    position: relative;
    border-radius: 8px;
    overflow: hidden;
    cursor: pointer;
  }
  
  .gallery-image {
    width: 100%;
    height: 250px;
    object-fit: cover;
    object-position: center 20%;
    border-radius: 8px;
    transition: transform 0.3s ease;
  }
  
  .image-description {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.7);
    color: white;
    padding: 0.75rem 1rem;
    transform: translateY(100%);
    transition: transform 0.3s ease;
  }
  
  .gallery-item:hover {
    .gallery-image {
      transform: scale(1.05);
    }
    
    .image-description {
      transform: translateY(0);
    }
  }
  
  .view-all-btn {
    margin-top: 2rem;
  }
  
  @media (max-width: 768px) {
    padding: 2rem 0;
    
    .gallery-image {
      height: 200px;
    }
  }
`;

const GalleryPreview = () => {
  const theme = useSelector(selectMode);

  const previewImages = [
    { 
      id: 1, 
      src: bridgeImg, 
      alt: "Bridge view",
      description: "Taken on Ohiopyle High Bridge, in Ohiopyle, Pennsylvania."
    },
    { 
      id: 2, 
      src: citiesAfarImg, 
      alt: "Cities from afar",
      description: "Cities Skylines: a city I built from scratch, this is the view of Apollotown taken afar."
    },
    { 
      id: 3, 
      src: mountRainierImg, 
      alt: "Mount Rainier",
      description: "Me and my girlfriend, Avery, at Mount Rainier, Washington."
    }
  ];

  return (
    <Element name="Gallery" id="gallery">
      <StyledSection>
        <Container className="gallery-container">
          <Container className="d-flex justify-content-center mb-5">
            <Title size="h2" text="Gallery" />
          </Container>
          <Row xs={1} md={2} lg={3} className="g-4">
            {previewImages.map((image) => (
              <Col key={image.id}>
                <div className="gallery-item">
                  <img
                    src={image.src}
                    alt={image.alt}
                    className="gallery-image"
                    loading="lazy"
                  />
                  <div className="image-description">
                    {image.description}
                  </div>
                </div>
              </Col>
            ))}
          </Row>
          <Container className="d-flex justify-content-center">
            <Link to="/gallery">
              <Button
                variant={theme === "light" ? "outline-dark" : "outline-light"}
                className="view-all-btn mt-4"
              >
                View Full Gallery
              </Button>
            </Link>
          </Container>
        </Container>
      </StyledSection>
    </Element>
  );
};

export default GalleryPreview;
